// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__g9_eI","infoWrapper":"Overview_infoWrapper__BbDUw","items":"Overview_items__6dydR","customIcon":"Overview_customIcon__Pb6NO"};